import React, { useMemo, useRef } from 'react';
import { ButtonStyle, Title, Wrap } from '../styled';
import useModal from '../useModal';
import styled from 'styled-components';
import { Widget } from 'models/widgetMultiStageOlympiad';
import MarkdownPreview from 'features/shared/ui/MarkdownPreview/MarkdownPreview';
import { markdownPrepareTextCopy } from 'utils/markdownCopyText';
import MultiStageOlympModal from '../../Modals/MultiStageOlympModal/MultiStageOlympModal';

export const NumberList = styled.div`
  display: flex;
  gap: 8px
`;

const InfoBlock = ({
  isSecondStarted,
  cabmunId,
  widget,
}: {
  isSecondStarted: boolean;
  cabmunId: number;
  widget: Widget;
}) => {
  const markdownRef = useRef<HTMLDivElement>(null);
  const eventCopyClick = {
    eventType: `regional_rating_modal_improve_result`,
    eventInfo: `Региональный рейтинг: Клик по кнопке Скопировать в модальном окне II тура`,
  };
  const eventOpenModal = {
    eventType: `reqional_rating_improve_result`,
    eventInfo: `Региональный рейтинг: Клик по кнопке Проинформировать муниципалитеты о II туре`
  }

  const messageToCopy = useMemo(() => {
    const plainText = markdownRef.current?.innerText || widget.modalMessage;
    return markdownPrepareTextCopy(plainText, cabmunId);
  }, [widget.modalMessage]);

  const { showModal, handleImproveClick, handleCloseModal, handleCopyClick } = useModal(
    eventOpenModal,
    eventCopyClick,
  );

  const title = isSecondStarted ? 'Стартовал II тур олимпиады' : `II тур пройдет ${widget.datesSecondTour}`;

  return (
    <Wrap style={{ padding: '16px 24px', display: 'grid', gap: '24px' }}>
      <Title>{title}</Title>
      {isSecondStarted && widget.secondTourSubInfo && (
        <div style={{ fontSize: '18px', lineHeight: '24px' }}>
          <MarkdownPreview content={widget.secondTourSubInfo} replaceUtmTerm={true} />
        </div>
      )}

      {!isSecondStarted && (
        <ButtonStyle color={'violet'} onClick={handleImproveClick} style={{ width: '360px' }}>
          проинформировать муниципалитеты
        </ButtonStyle>
      )}
      {showModal && (
        <MultiStageOlympModal
          onCopyClick={handleCopyClick}
          title="Проинформировать муниципалитеты о проведении II тура"
          onClose={handleCloseModal}
          cabmunId={cabmunId}
          textMessageCopy={widget.modalMessage}
        />
      )}
    </Wrap>
  );
};
export default InfoBlock;